import { render, staticRenderFns } from "./Alpha.vue?vue&type=template&id=51476de8&"
import script from "./Alpha.vue?vue&type=script&lang=ts&"
export * from "./Alpha.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports